import { Component, Inject, NgZone, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CartService } from './shared/services/cart.service';
import { CompareService } from './shared/services/compare.service';
import { WishlistService } from './shared/services/wishlist.service';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { CurrencyService } from './shared/services/currency.service';
import { filter, first, take, takeUntil } from 'rxjs/operators';
import { LoaderService } from './shared/services/loader.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { NavigationService } from './services/navigation.service';
import { SharedDataService } from './services/shared-data-service.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly _destroying$ = new Subject<void>();
    loader$ = this.loader.loader$;
    private isLoginInProgress = false;
    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private loader: LoaderService,
        private router: Router,
        private toastr: ToastrService,
        private cart: CartService,
        private compare: CompareService,
        private wishlist: WishlistService,
        private zone: NgZone,
        private scroller: ViewportScroller,
        private currency: CurrencyService,
        private msalService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private navigate: NavigationService,
        private sharedDataService: SharedDataService,
    ) {


        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                this.router.events.pipe(filter(event => event instanceof NavigationEnd), first()).subscribe(() => {
                    const preloader = document.querySelector('.loader-bg');

                    if (preloader === null) {
                        return;
                    }

                    preloader.addEventListener('transitionend', (event: Event) => {
                        if (event instanceof TransitionEvent && event.propertyName === 'opacity') {
                            preloader.remove();
                        }
                    });
                    preloader.classList.add('site-preloader__fade');

                    // Sometimes, due to unexpected behavior, the browser (in particular Safari) may not play the transition, which leads
                    // to blocking interaction with page elements due to the fact that the preloader is not deleted.
                    // The following block covers this case.
                    if (getComputedStyle(preloader).opacity === '0' && preloader.parentNode) {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
            });
        }
    }

    ngOnInit(): void {
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                const currentUrl = this.router.url;
                const token = localStorage.getItem('token');
                if (currentUrl.includes('/loginTrendAnalysis') || (!currentUrl.includes('/login') && !currentUrl.includes('/loginauth'))) {
                    return;
                }
                if (token && !this.isTokenExpired(token)) {
                    this.router.navigate(['/dashboard']);
                    return;
                }


                const accounts = this.msalService.instance.getAllAccounts();
                if (accounts.length > 0) {
                    this.navigate.goToLoginauth();
                }
            });

        // properties of the CurrencyFormatOptions interface fully complies
        // with the arguments of the built-in pipe "currency"
        // https://angular.io/api/common/CurrencyPipe
        this.currency.options = {
            code: 'R ',
            // display: 'symbol',
            // digitsInfo: '1.2-2',
            // locale: 'en-ZA',
        };

        this.router.events.subscribe((event) => {
            if ((event instanceof NavigationEnd)) {
                this.scroller.scrollToPosition([0, 0]);
            }
        });
        this.inactivityTime();
    }


    private isTokenExpired(token: string): boolean {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const valid: any = Math.floor(Date.now() / 1000) >= payload.exp;
            console.log("token expiered or not" + valid);

            return valid;
        } catch (e) {
            return true;
        }
    }

    inactivityTime() {
        var t;
        const defaultSessionTimeout = 15 * 60 * 1000;
        document.addEventListener('load', resetTimer, true);
        document.addEventListener('mousemove', resetTimer, true);
        document.addEventListener('mousedown', resetTimer, true);
        document.addEventListener('touchstart', resetTimer, true);
        document.addEventListener('click', resetTimer, true);
        document.addEventListener('keydown', resetTimer, true);
        document.addEventListener('keypress', resetTimer, true);
        document.addEventListener('scroll', resetTimer, true);



        function broadcastActivity() {
            localStorage.setItem('activityBroadcast', Date.now().toString());
        }

        function logout() {
            const currentURL = window.location.pathname; // Get the current page path
            if (currentURL !== '/auth/login') {
                sessionStorage.clear();
                localStorage.clear();
                location.href = 'auth/login';
                console.log('session clear');
            }

        }

        function resetTimer() {
            clearTimeout(t);
            t = setTimeout(logout, defaultSessionTimeout)
            broadcastActivity();
            // 1000 milisec = 1 sec
        }

        window.addEventListener('storage', (event) => {
            if (event.key === 'activityBroadcast') {
                clearTimeout(t); // Reset timer if activity is detected in another tab
                resetTimer(); // Restart the timer
            }
        });

    };

    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
}
